<template>
	<VuePerfectScrollbar
		:settings="settings"
		class="pr-4">
		<div class="order-history">
			<p
				v-if="!logRows.length"
				class="order-history__empty text-muted"
			>
				{{ $t("noDataAvailable") }}
			</p>
			<table
				v-else
				class="order-history__table"
			>
				<thead>
					<tr>
						<th>{{ $t("orderHistory.entityType") }}</th>
						<th>{{ $t("orderHistory.initiatorRole") }}</th>
						<th>{{ $t("orderHistory.initiatorName") }}</th>
						<th>{{ $t("orderHistory.field") }}</th>
            <th>{{ $t("orderHistory.new") }}</th>
            <th>{{ $t("orderHistory.old") }}</th>
						<th>{{ $t("orderHistory.createdAt") }}</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="row in logRows"
						:key="row.rowKey"
					>
						<td>{{ row.entity_type_label }}</td>
						<td>{{ row.initiator_role }}</td>
						<td>{{ row.initiator_name }}</td>
						<td>{{ row.field_label }}</td>
            <td>{{ row.new }}</td>
            <td>{{ row.old }}</td>
						<td>{{ row.created_at }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</VuePerfectScrollbar>
</template>

<script>
import databaseManager from "../../mixins/databaseManager";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	name: "OrderHistory",
	mixins: [databaseManager],
	components: {
		VuePerfectScrollbar,
	},
	props: {
		orderId: { type: Number },
	},
	data() {
		return {
			orderLog: [],
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 1,
				swipeEasing: true
			},
		};
	},
	computed: {
		logRows() {
			const rows = [];
			const list = Array.isArray(this.orderLog) ? this.orderLog : [];
			for (const entry of list) {
				const dataItems = Array.isArray(entry.data) && entry.data.length
					? entry.data
					: [{ field_label: "", old: "", new: "" }];
				dataItems.forEach((d, i) => {
					rows.push({
						rowKey: `${entry.id}-${i}`,
						entity_type_label: entry.entity_type_label,
						initiator_role: entry.initiator_role,
						initiator_name: entry.initiator_name,
						field_label: d.field_label,
						old: d.old,
						new: d.new,
						created_at: entry.created_at,
					});
				});
			}
			return rows;
		},
	},
	async mounted() {
		this.orderLog = await this.dbGetSystemLogList(this.orderId);
	},

}
</script>

<style scoped lang="scss">
.order-history {
	padding-bottom: 1rem;
}

.order-history__empty {
	margin: 0;
	padding: 0.5rem 0;
}

.order-history__table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.875rem;

	th,
	td {
		border: 1px solid rgba(0, 0, 0, 0.08);
		padding: 0.5rem 0.65rem;
		text-align: left;
		vertical-align: top;
	}

	th {
		font-weight: 600;
		background: rgba(0, 0, 0, 0.03);
		white-space: nowrap;
	}

	tbody tr:nth-child(even) {
		background: rgba(0, 0, 0, 0.02);
	}
}
</style>
